export default __webpack_public_path__ + "static/media/atlantis3.3f3f71e9.jpg";